import type { ClientEnvT } from '../../env/clientEnvSchema';

export const env = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_MARKET_FEED_BASE_URL: import.meta.env.VITE_MARKET_FEED_BASE_URL,
  VITE_PRIVY_APP_ID: import.meta.env.VITE_PRIVY_APP_ID,
  VITE_RELEASE: import.meta.env.VITE_RELEASE,
  VITE_SENTRY_DSN:
    import.meta.env.VITE_SENTRY_DSN === 'disabled'
      ? null
      : import.meta.env.VITE_SENTRY_DSN,
} satisfies ClientEnvT;
